import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const MoneyCoinIcon: FunctionComponent<IIconProps & { outlined?: boolean }> = ({
  outlined,
  ...props
}) => (
  <Icon {...{ viewBox: '0 0 24 24', ...props }}>
    <Path
      fill="currentColor"
      d="M11.82 23.65C5.3 23.65 0 18.34 0 11.82 0 5.3 5.3 0 11.82 0c2.88 0 5.66 1.05 7.82 2.95a.998.998 0 1 1-1.32 1.5A9.808 9.808 0 0 0 11.83 2C6.41 2 2 6.41 2 11.82s4.41 9.82 9.82 9.82a9.8 9.8 0 0 0 9.53-7.45 1 1 0 0 1 1.94.48 11.791 11.791 0 0 1-11.47 8.96v.02Z"
    />
    <Path
      fill="currentColor"
      d="M12.57 4.65v1.2h1.4c.55 0 1 .45 1 1s-.45 1-1 1h-2.4c-.37 0-.73.15-.99.41s-.41.62-.41.99.15.73.41.99.62.41.99.41c.9 0 1.77.36 2.4 1 .64.64 1 1.5 1 2.4 0 .9-.36 1.77-1 2.4-.4.4-.88.68-1.4.85v.35c0 .55-.45 1-1 1s-1-.45-1-1v-.2h-1.4c-.55 0-1-.45-1-1s.45-1 1-1h2.4c.37 0 .73-.15.99-.41s.41-.62.41-.99-.15-.73-.41-.99-.62-.41-.99-.41c-.9 0-1.77-.36-2.4-1-.64-.64-1-1.5-1-2.4 0-.9.36-1.77 1-2.4.4-.4.88-.68 1.4-.85V4.65c0-.55.45-1 1-1s1 .45 1 1ZM18.62 13.26c-.26 0-.52-.1-.71-.29l-2.13-2.13a.996.996 0 1 1 1.41-1.41l1.24 1.24 2.88-4.61a1.003 1.003 0 0 1 1.7 1.06l-3.55 5.68c-.16.26-.43.43-.73.46h-.11Z"
    />
  </Icon>
)
